import React from "react";
import { cn } from "utils";
import { CardSkeleton } from "./CardSkeleton";
import { ContentSkeleton } from "./ContentSkeleton";
import { RightSkeleton } from "./RightSkeleton";

interface TokenDetailsSkeletonProps {
  className?: string;
}

export const TokenDetailsSkeleton: React.FC<TokenDetailsSkeletonProps> = ({
  className,
}) => {
  return (
    <div className={cn("w-full max-w-[1104px]", className)}>
      <div className="mx-auto">
        <CardSkeleton />
        <div className="flex gap-[26px] mt-6">
          <ContentSkeleton />
          <RightSkeleton />
        </div>
      </div>
    </div>
  );
};
